import React, { useState, useCallback, useEffect } from "react";
import {
  Badge,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  TextContainer,
  Toast,
  Page,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import AddUser from "./Modals/AddUser";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import moment from "moment";
import Pagination from "@material-ui/lab/Pagination";
import EditUser from "./Modals/EditUser";
import { useNavigate } from "react-router-dom";
import { adminRole } from "../Helpers";

const UsersAndPermissions = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const format = "YYYY-MM-DD HH:mm:ss";
  const modalId = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const rows = [
    ["Emerald Silk Gown", "$875.00", 124689, 140, "$122,500.00"],
    ["Mauve Cashmere Scarf", "$230.00", 124533, 83, "$19,090.00"],
    [
      "Navy Merino Wool Blazer with khaki chinos and yellow belt",
      "$445.00",
      124518,
      32,
      "$14,240.00",
    ],
  ];
  const [activeAddUser, setActiveAddUser] = useState(false);
  const handleAddUser = () => {
    modalId.current = "add-user";
    setActiveModal(true);
  };
  const [activeModal, setActiveModal] = useState(false);
  const handleChangeModal = () => {
    setActiveModal(!activeModal);
  };
  const handleChangeModalAndRefresh = () => {
    setActiveModal(!activeModal);
    setIsSaving(false);
    setTs(+new Date());
    setToastContent("Changes saved successfully");
    toggleActive();
  };
  const handleSubmitModal = () => {
    ref.current.handleSave();
  };
  const handleSavingState = () => {
    setIsSaving(true);
  };
  const handleResetSaving = () => {
    setIsSaving(false);
  };
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  useEffect(() => {
    getData();
  }, [ts]);
  const getData = () => {
    axios
      .get(
        `/management/users?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }`
      )
      .then((result) => {
        !result.data.data.data.length
          ? setIsListEmpty(true)
          : setIsListEmpty(false);
        // setTotalPages(result.data.data.total);
        setItems(
          result.data.data.data.map((item, index) => [
            // item?.id && item.id,
            <div className="row_click2">
              {item?.first_name && item.first_name}
            </div>,
            <div className="row_click2">
              {item?.last_name && item.last_name}
            </div>,
            <div className="row_click2">{item?.email && item.email}</div>,
            <div className="row_click2">
              {item?.roles[0] && <Badge>{item?.roles[0].name}</Badge>}
            </div>,
            // item?.created_at && moment(item.created_at).format(format),
            <div className="me-3">
              <ButtonGroup>
                <Button
                  onClick={() => handleEdit(item.id)}
                  disabled={adminRole() !== "Super"}
                >
                  Edit
                </Button>
                {/* <Button destructive onClick={() => handleDelete(item.id)}>
                Delete
              </Button> */}
              </ButtonGroup>
            </div>,
          ])
        );
        setIsLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
        }
      });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const clickedUser = useRef(null);
  const handleEdit = (id) => {
    clickedUser.current = id;
    modalId.current = "edit-user";
    setActiveModal(true);
  };
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = () => {
    setActiveModal(false);
    // clickedUser.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/management/users/${clickedUser.current}`)
      .then((result) => {
        setToastContent("This user has been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const switchModalTitle = (param) => {
    switch (param) {
      case "add-user":
        return "Add User";
      case "edit-user":
        return "Edit User";
      default:
        return null;
    }
  };

  return (
    adminRole() === "Super" && (
      <Page
        title="Users and Permissions"
        primaryAction={
          <Button
            primary
            onClick={handleAddUser}
            disabled={adminRole() !== "Super"}
          >
            Add User
          </Button>
        }
      >
        <Card>
          {loadingMarkup}
          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   ID
              // </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                First Name
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Last Name
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Email
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Role
              </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Created at
              // </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            verticalAlign="middle"
            increasedTableDensity
          />
          {emtyState}
          {totalPages >= 2 && (
            <div
              style={{
                paddingTop: "10px",
                textAlign: "center",
                paddingBottom: "10px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                size="large"
              />
            </div>
          )}
          <Modal
            open={activeModal}
            onClose={handleChangeModal}
            title={switchModalTitle(modalId.current)}
            primaryAction={{
              content: "Submit",
              onAction: handleSubmitModal,
              loading: isSaving,
            }}
            secondaryActions={
              modalId.current === "edit-user" && [
                {
                  content: "Delete",
                  destructive: true,
                  onAction: handleDelete,
                  loading: isSaving,
                },
              ]
            }
          >
            <Modal.Section>
              {modalId.current === "add-user" && (
                <AddUser
                  ref={ref}
                  handleChangeModalAndRefresh={handleChangeModalAndRefresh}
                  handleSavingState={handleSavingState}
                  handleResetSaving={handleResetSaving}
                />
              )}
              {modalId.current === "edit-user" && (
                <EditUser
                  ref={ref}
                  handleChangeModalAndRefresh={handleChangeModalAndRefresh}
                  id={clickedUser.current}
                  handleSavingState={handleSavingState}
                  handleResetSaving={handleResetSaving}
                />
              )}
            </Modal.Section>
          </Modal>

          <Modal
            open={activeDelete}
            onClose={handleChangeModalDelete}
            title="Delete User"
            primaryAction={{
              content: "Yes",
              onAction: handleYesDelete,
              loading: isSaving,
            }}
            secondaryActions={[
              {
                content: "No",
                loading: isSaving,
                onAction: handleChangeModalDelete,
              },
            ]}
          >
            <Modal.Section>
              <TextContainer>
                <p>Are you sure you want to delete this user?</p>
              </TextContainer>
            </Modal.Section>
          </Modal>
          {toastMarkup}
        </Card>
      </Page>
    )
  );
};

export default UsersAndPermissions;
